var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { units, type } = options; 
__p+='\n';
 units.forEach(function(unit){ 
__p+='\n  <tr>\n    <td class="bdp-sticky-col">\n      <a href="'+
((__t=( unit.ldp_url ))==null?'':__t)+
'" title="'+
((__t=(unit.address_display))==null?'':__t)+
'" class="js-bu-link" data-omtag="'+
((__t=('bdp:all-units:' + type ))==null?'':__t)+
'">'+
((__t=( unit.unit_number ? unit.unit_number : "Unit" ))==null?'':__t)+
'</a>\n    </td>\n    <td>\n      ';
 if(unit.price_display){ 
__p+='\n        '+
((__t=( unit.price_display ))==null?'':__t)+
'\n      ';
 } else { 
__p+='\n        n/a\n      ';
 } 
__p+='\n    </td>\n    ';
 if(type == "off_market") { 
__p+='\n      <td>\n        ';
 if(unit.sold_price_display){ 
__p+='\n          '+
((__t=( unit.sold_price_display ))==null?'':__t)+
'\n        ';
 } else { 
__p+='\n          n/a\n        ';
 } 
__p+='\n      </td>\n    ';
 } 
__p+='\n    <td>\n      ';
 if(unit.beds_display){ 
__p+='\n        '+
((__t=( unit.beds_display ))==null?'':__t)+
'\n      ';
 } else { 
__p+='\n        n/a\n      ';
 } 
__p+='\n    </td>\n    <td>\n      ';
 if(unit.baths_display){ 
__p+='\n        '+
((__t=( unit.baths_display ))==null?'':__t)+
'\n      ';
 } else { 
__p+='\n        n/a\n      ';
 } 
__p+='\n    </td>\n    <td>\n      ';
 if(unit.sqft_display && unit.sqft_display != "0 sq ft"){ 
__p+='\n        '+
((__t=( unit.sqft_display ))==null?'':__t)+
'\n      ';
 } else { 
__p+='\n        n/a\n      ';
 } 
__p+='\n    </td>\n    ';
 if(type == "for_sale") { 
__p+='\n      <td>\n        ';
 if(unit.days_on_market){ 
__p+='\n          '+
((__t=( unit.days_on_market ))==null?'':__t)+
'\n        ';
 } else { 
__p+='\n          n/a\n        ';
 } 
__p+='\n      </td>\n    ';
 } 
__p+='\n    ';
 if(type == "for_rent") { 
__p+='\n      <td>\n        '+
((__t=( unit.fee ))==null?'':__t)+
'\n      </td>\n    ';
 } 
__p+='\n  </tr>\n';
 }) 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/building_table.jst.ejs